import React, { useEffect } from 'react'
import styles from './broadcasts__downloadInfo.jcss'
import Button from '../../../blocks.simple/button/button'
import { getThemeStyleValue } from '../../../theme/colors'
import { defaultThemeStyles } from '../../../blocks.simple/icon/icon.theme'
import Icon from '../../../blocks.simple/icon/icon'
import translate from '../../../core/translate'
import helpers from '../../../core/helpers'

const DOWNLOAD_INFO_MODAL_ID = 'downloadInfoModal'

export const DownloadInfoModal = ({
    onClose,
    progressList,
    type = 'broadcast',
}: {
    onClose: () => void
    progressList: any[]
    type?: 'broadcast' | 'advertisement'
}) => {
    const messageKeys =
        type === 'advertisement'
            ? (['prepareAdvertisementDownload_1', 'prepareAdvertisementDownload_2'] as const)
            : (['prepareBroadcastDownload_1', 'prepareBroadcastDownload_2'] as const)

    useEffect(() => {
        helpers.disableWindowScroll(true, DOWNLOAD_INFO_MODAL_ID)

        return () => {
            helpers.disableWindowScroll(false, DOWNLOAD_INFO_MODAL_ID)
        }
    }, [])

    return (
        <div className={styles.modalInfoWrapper} onClick={onClose}>
            <div className={styles.modalInfo} onClick={(e) => e.stopPropagation()}>
                <Icon
                    type={'broadcastDownloadProgress'}
                    size={61}
                    color={getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable}
                />
                <div className={styles.modalInfoMessage}>
                    {translate(messageKeys[0]) + ' '}
                    {' ' + translate(messageKeys[1])}
                </div>
                {progressList.length ? (
                    <div className={styles.progress}>
                        <div className={styles.progressTitle}>{translate('inProgress')}:</div>
                        {progressList.map((progress) => {
                            return <div className={styles.progressItem}>{`${progress.name} ${progress.percent}%`}</div>
                        })}
                    </div>
                ) : null}
                <Button className={styles.closeBtn} mod={'withBorder'} onClick={onClose}>
                    {translate('close')}
                </Button>
            </div>
        </div>
    )
}
